import { hashString, mulberry32 } from '@/lib/math'

/** Width and height of the brush's viewBox. It stretches to the phrase (`preserveAspectRatio="none"`). */
export const BRUSH_VIEWBOX = '0 0 100 10'

/**
 * A filled, hand-drawn brush stroke: a gently bowed centre line with a pen's taper at both
 * ends and a faint wobble. Seeded by the phrase, so each underline is unique but stable.
 * Filled rather than stroked, so stretching it to any width keeps the ends tapered.
 */
export function brushPath(seed: string): string {
  const random = mulberry32(hashString(seed))
  const steps = 32
  const slope = (random() - 0.5) * 1.8
  const bow = 0.6 + random() * 0.9
  const phase = random() * Math.PI * 2
  const weight = 1.5 + random() * 0.3
  const top: string[] = []
  const bottom: string[] = []
  for (let i = 0; i <= steps; i++) {
    const t = i / steps
    const x = 1 + t * 98
    const centre =
      5.6 + slope * (t - 0.5) - bow * Math.sin(Math.PI * t) + Math.sin(t * 6.5 + phase) * 0.22
    // Heavier where the pen lands, lighter as it lifts off.
    const taper = Math.pow(Math.sin(Math.PI * t), 0.5) * (1 - 0.35 * t)
    const half = weight * taper * (1 + (random() - 0.5) * 0.12)
    top.push(`${x.toFixed(2)} ${(centre - half).toFixed(2)}`)
    bottom.push(`${x.toFixed(2)} ${(centre + half).toFixed(2)}`)
  }
  return `M${top.join('L')}L${bottom.reverse().join('L')}Z`
}
